import React, { useState, useRef } from "react"
import { updateFormState } from "src/utils/updateFormState"
import axios from "axios"
import * as qs from "query-string"

import Button from "src/components/ui/Button"
import FormGroup from "src/components/ui/FormGroup"

import * as S from "./styled"

const ContactForm = () => {
  const defaultFormCtrls = {
    name: {
      label: "Seu nome",
      type: "input",
      placeholder: "Seu nome",
      value: "",
      validation: {
        required: true,
        isValid: false,
        error: "",
        touched: false,
        minLength: 7,
      },
    },

    email: {
      label: "Seu email",
      type: "input",
      placeholder: "Seu email",
      value: "",
      validation: {
        required: true,
        isValid: false,
        error: "",
        touched: false,
        isEmail: true,
      },
    },

    phone: {
      label: "Seu telefone",
      type: "input-mask",
      placeholder: "Seu telefone",
      mask: "(99) 99999-9999",
      value: "",
      validation: {
        required: true,
        isValid: false,
        error: "",
        touched: false,
        minLength: 10,
      },
    },

    message: {
      label: "Sua mensagem",
      type: "textarea",
      placeholder: "Sua mensagem...",
      value: "",
      validation: {
        required: true,
        isValid: false,
        error: "",
        touched: false,
        minLength: 10,
      },
    },
  }

  const [isFormValid, setIsFormValid] = useState(false)

  const [formCtrls, setFormCtrls] = useState(defaultFormCtrls)

  const [isFetching, setIsFetching] = useState(false)

  const [fetchingResult, setFetchingResult] = useState(false)

  const inputChangeHandler = (e, key) => {
    const [newIsFormValid, newFormCtrls] = updateFormState(e, key, formCtrls)
    setIsFormValid(newIsFormValid)
    setFormCtrls(newFormCtrls)
  }

  const forceValidating = () => {
    if (isFormValid) {
      return true
    }

    const newFormCtrls = {
      ...formCtrls,
    }

    Object.keys(newFormCtrls).map((key, index) => {
      newFormCtrls[key].validation.touched = true
    })

    setFormCtrls(newFormCtrls)
    return false
  }

  const fetchForm = () => {
    if (forceValidating()) {
      setIsFetching(true)

      const formData = {}
      Object.keys(formCtrls).map((key, index) => {
        formData[key] = formCtrls[key].value
      })

      const axiosOptions = {
        url: "/",
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        data: qs.stringify({
          ...formData,
          "form-name": "contact",
        }),
      }
      axios(axiosOptions)
        .then(response => {
          setIsFetching(false)
          setFetchingResult("Mensagem enviada :)")
        })
        .catch(err => {
          setFetchingResult("Falha ao enviar :(")
        })
    }
  }

  return (
    <S.ContactFormWrapper method="POST" name="contact" data-netlify={true}>
      {Object.keys(formCtrls).map((key, index) => {
        const input = formCtrls[key]

        return (
          <FormGroup
            key={key}
            label={input.label}
            mask={input.mask || false}
            type={input.type || "input"}
            name={key}
            value={input.value}
            error={input.validation.error}
            isInvalid={!input.validation.isValid}
            isTouched={input.validation.touched}
            placeholder={input.placeholder}
            onChangeHandler={inputChangeHandler}
          />
        )
      })}

      {!isFetching && !fetchingResult ? (
        <Button
          color={"primary"}
          hasIconAfter={`Send`}
          size={"lg"}
          onClick={fetchForm}
        >
          Enviar mensagem
        </Button>
      ) : (
        <Button
          color={"primary"}
          size={"lg"}
          disabled={true}
          onClick={fetchForm}
        >
          {fetchingResult ? fetchingResult : "Enviando..."}
        </Button>
      )}
    </S.ContactFormWrapper>
  )
}

export default ContactForm
